// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "./AuthProvider";

export default function ProtectedRoute({ children }) {
    const { user, isLoading } = useAuth();

    // If still loading user from server
    if (isLoading) {
        return (
            <div className="loadingContainer">
                <CircularProgress color="secondary" className="loadingCircle" />
            </div>
        );
    }

    // If no user => redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // If user is valid => render children
    return children;
}
